import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IPagingInfoWithOrder } from '../../../../../models/paginationInfo.model';
import { IMainApiService, IPagedResult } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';
import { IProjectToolStatisticsDto, IStatisticsListItem } from '../projectDetailsStatistics.model';

export interface IProjectDetailsStatisticsApiService {
  getProjectStatisticsAsync: (projectId: string, pagingInfo: IPagingInfoWithOrder) => Promise<IPagedResult<IStatisticsListItem> | ACDLError>;
  getProjectToolStatistics: (projectId: string) => Promise<IProjectToolStatisticsDto | ACDLError>;
  refreshToolStatistics: (projectId: string) => Promise<IProjectToolStatisticsDto | ACDLError>;
}

export namespace IProjectDetailsStatisticsApiService {
  export const $: interfaces.ServiceIdentifier<IProjectDetailsStatisticsApiService> = Symbol('PROJECT_DETAILS_STATISTICS_API_SERVICE');
}

@injectable()
export class ProjectDetailsStatisticsApiService implements IProjectDetailsStatisticsApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  getProjectToolStatistics = async (projectId: string): Promise<IProjectToolStatisticsDto | ACDLError> => {
    return this.apiService.getAsync<IProjectToolStatisticsDto>(`/projects/GetProjectToolStatistics?ProjectId=${projectId}`);
  };

  refreshToolStatistics = async (projectId: string): Promise<IProjectToolStatisticsDto | ACDLError> => {
    return this.apiService.getAsync<IProjectToolStatisticsDto>(`/projects/RefreshProjectToolStatistics?ProjectId=${projectId}`);
  };

  getProjectStatisticsAsync = async (projectId: string, pagingInfo: IPagingInfoWithOrder): Promise<ACDLError | IPagedResult<IStatisticsListItem>> => {
    const { pageNumber, pageSize, orderBy, orderType } = pagingInfo;
    const url = `/Projects/Statistics?ProjectId=${projectId}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&orderType=${orderType}`;
    return await this.apiService.getAsync<IPagedResult<IStatisticsListItem>>(url);
  };
}
